<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/library-management" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Library Management
            </router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v mx-2"></i>Books Stock Summary</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="justify-content-end form-inline mt-3">
                        <base-input class="input-group-alternative" placeholder="Search here..."
                            addon-left-icon="fa fa-search" v-model="searchval">
                        </base-input>
                    </div>
                    <div class="table-responsive mt-2">
                        <table class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Book</th>
                                    <th>Book Edition</th>
                                    <th>Category</th>
                                    <th>Qty In Stock</th>
                                    <th>Qty Borrowed</th>
                                    <th>Qty Remain</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in searchedResultQuery" :key="item.Id">
                                    <td>{{ item.BookTitle }}</td>
                                    <td>{{ item.BookEdition }}</td>
                                    <td>{{ item.Category }}</td>
                                    <td>{{ item.QtyInStock }}</td>
                                    <td>{{ item.QtyBorrowed }}</td>
                                    <td>{{ item.QtyRemain }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </card>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import DateFormaterMixin from "@/mixins/DateFormater.mixin";
import libraryBookStockSummaryMixin from "@/mixins/libraryBookStockSummary.mixin";
import PageSpinner from "@/components/PageSpinner";

export default {
    name: "LibraryBookReturn",
    mixins: [DateFormaterMixin, libraryBookStockSummaryMixin, Alert],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            LibraryBookStockSummaryItems: null,
            searchval: '',
            onloader: "none"
        };
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.LibraryBookStockSummaryItems.filter(item => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            v =>
                                item.BookTitle.toLowerCase().includes(v) ||
                                item.BookEdition.toLowerCase().includes(v) ||
                                item.Category.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.LibraryBookStockSummaryItems;
            }
        }
    },
    methods: {

    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        }
    }
};
</script>

<style></style>
